import React from "react";

function Shipping() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512.006 512.006"
    >
      <path
        fill="#ffa95f"
        d="M499.834 307.445l-27.105-19.378-.365-76.364c-.033-6.975-5.072-11.814-12.302-11.814h-83.948l-51.55 192.387h144.29c8.854 0 17.956-7.178 20.328-16.032l14.751-55.052c1.51-5.631-.046-10.849-4.099-13.747z"
        data-original="#ffa95f"
      ></path>
      <path
        fill="#ff8b5a"
        d="M376.957 368.229c-1.153 0-2.708-.237-3.573-1.364-.776-1.012-.93-2.68-.421-4.578l9.147-34.139h-40.363l-17.183 64.129h144.29c8.855 0 17.955-7.178 20.328-16.032l2.148-8.016z"
        data-original="#ff8b5a"
      ></path>
      <path
        fill="#ffc269"
        d="M499.834 307.445l-27.105-19.378-.365-76.364c-.033-6.975-5.072-11.814-12.302-11.814h-43.585L382.11 328.147h119.96l1.864-6.955c1.509-5.631-.047-10.849-4.1-13.747z"
        data-original="#ffc269"
      ></path>
      <path
        fill="#cee564"
        d="M163.975 183.858h224.452c4.427 0 7.054 3.589 5.868 8.016l-53.698 200.403H108.129c-4.427 0-7.054-3.589-5.868-8.016l51.55-192.387c1.186-4.427 5.737-8.016 10.164-8.016z"
        data-original="#e5646e"
      ></path>
      <path
        fill="#cedb46"
        d="M340.597 392.277l6.444-24.048H141.128c-5.165 0-8.925-4.899-7.588-9.889l6.291-23.484c1.189-4.438 5.877-6.766 10.243-5.335 16.223 5.317 33.363 7.481 50.748 6.351 62.92-4.088 113.173-53.215 125.162-115.117 2.496-12.887 2.788-22.684 1.09-36.898h-163.1c-4.427 0-8.978 3.589-10.164 8.016L102.26 384.26c-1.186 4.427 1.44 8.016 5.868 8.016h232.469z"
        data-original="#db4655"
      ></path>
      <ellipse
        cx="428.774"
        cy="392.277"
        fill="#5d5360"
        data-original="#5d5360"
        rx="36.647"
        ry="28.055"
        transform="rotate(-41.2 428.408 391.988)"
      ></ellipse>
      <ellipse
        cx="180.274"
        cy="392.277"
        fill="#5d5360"
        data-original="#5d5360"
        rx="36.647"
        ry="28.055"
        transform="rotate(-41.2 180.107 391.974)"
      ></ellipse>
      <path
        fill="#dbeaff"
        d="M416.617 288.067h56.113l-.268-56.113h-40.809c-8.854 0-17.955 7.178-20.328 16.032l-6.444 24.048c-2.373 8.855 2.881 16.033 11.736 16.033z"
        data-original="#dbeaff"
      ></path>
      <circle
        cx="191.871"
        cy="199.89"
        r="112.226"
        fill="#eceaec"
        data-original="#eceaec"
      ></circle>
      <circle
        cx="191.871"
        cy="199.89"
        r="88.177"
        fill="#fff"
        data-original="#ffffff"
      ></circle>
      <circle
        cx="191.871"
        cy="199.89"
        r="16.032"
        fill="#5d5360"
        data-original="#5d5360"
      ></circle>
      <path
        fill="#c3ddff"
        d="M472.729 288.067l-.114-24.048h-35.67c-1.152 0-2.707-.237-3.571-1.364-.777-1.012-.931-2.68-.422-4.578l6.444-24.049.556-2.074h-8.299c-8.855 0-17.956 7.178-20.328 16.032l-6.445 24.048c-2.372 8.854 2.883 16.032 11.737 16.032h56.112z"
        data-original="#c3ddff"
      ></path>
      <path
        d="M428.774 384.777a7.5 7.5 0 000 15h.08c4.142 0 7.46-3.358 7.46-7.5s-3.397-7.5-7.54-7.5zm-248.5 0a7.5 7.5 0 000 15h.08c4.142 0 7.46-3.358 7.46-7.5s-3.397-7.5-7.54-7.5z"
        data-original="#000000"
      ></path>
      <path
        d="M504.196 301.345l-23.985-17.148-.346-72.529c-.054-11.17-8.382-19.278-19.802-19.278h-58.221c.682-3.954-.193-7.842-2.499-10.848-2.528-3.294-6.507-5.184-10.916-5.184h-52.266a7.5 7.5 0 000 15l50.507.001-51.827 193.418H220.94c.154-7.512-1.98-14.552-6.261-20.131-5.905-7.695-15.072-11.934-25.813-11.934-19.304 0-38.466 13.695-46.014 32.065l-32.965-.001 14.654-54.689a7.5 7.5 0 00-5.304-9.186c-3.994-1.068-8.113 1.302-9.186 5.304L95.016 382.32c-1.188 4.432-.387 8.906 2.197 12.273 2.528 3.294 6.507 5.184 10.916 5.184h31.48c-.154 7.512 1.979 14.551 6.26 20.13 5.905 7.696 15.072 11.934 25.813 11.934 19.304 0 38.466-13.695 46.014-32.064h170.413c-.154 7.512 1.979 14.551 6.26 20.13 5.905 7.696 15.072 11.934 25.813 11.934 19.304 0 38.466-13.695 46.014-32.064h2.659c12.217 0 24.329-9.484 27.573-21.592l14.751-55.051c2.329-8.696-.346-17.045-6.983-21.789zm-299.102 88.991c-3.85 14.367-19.15 26.505-33.412 26.505-5.97 0-10.911-2.154-13.913-6.065-3.228-4.206-4.05-10.086-2.315-16.558 3.849-14.368 19.15-26.506 33.412-26.506 5.97 0 10.911 2.154 13.913 6.065 3.227 4.207 4.05 10.087 2.315 16.559zm260.099-109.769h-48.577c-1.268 0-2.988-.271-3.981-1.565-.875-1.14-1.061-2.972-.51-5.026l6.443-24.048c1.495-5.579 7.609-10.473 13.083-10.473h33.345zm-11.599 109.769c-3.85 14.367-19.15 26.505-33.412 26.505-5.97 0-10.911-2.154-13.913-6.065-3.228-4.206-4.05-10.086-2.315-16.558 3.849-14.368 19.15-26.506 33.412-26.506 5.97 0 10.911 2.154 13.913 6.065 3.227 4.207 4.05 10.087 2.315 16.559zm28.344-16.032c-1.442 5.381-7.18 10.112-12.498 10.442.147-7.5-1.987-14.528-6.262-20.099-5.905-7.695-15.072-11.934-25.813-11.934-19.304 0-38.466 13.695-46.014 32.065H350.37l13.164-49.129h90.438a7.5 7.5 0 000-15h-86.419L397.9 207.391h62.161c2.181 0 4.785.755 4.802 4.35l.061 12.715H431.65c-12.217 0-24.329 9.484-27.573 21.591l-6.443 24.048c-1.767 6.594-.637 13.169 3.1 18.039 3.625 4.725 9.414 7.434 15.881 7.434h53.708l25.148 17.98c2.138 1.528 1.472 4.753 1.217 5.705l-.374 1.396h-10.277a7.5 7.5 0 000 15h6.258z"
        data-original="#000000"
      ></path>
      <path
        d="M191.871 319.616c66.017 0 119.726-53.708 119.726-119.726S257.888 80.164 191.871 80.164 72.145 133.873 72.145 199.89s53.709 119.726 119.726 119.726zm0-224.452c57.746 0 104.726 46.98 104.726 104.726s-46.979 104.726-104.726 104.726S87.145 257.636 87.145 199.89s46.98-104.726 104.726-104.726z"
        data-original="#000000"
      ></path>
      <path
        d="M159.807 239.454a7.474 7.474 0 005.303-2.197l16.298-16.298a23.379 23.379 0 0010.463 2.463c12.976 0 23.532-10.557 23.532-23.532 0-3.757-.89-7.309-2.463-10.463l40.347-40.346a7.5 7.5 0 000-10.606 7.498 7.498 0 00-10.606 0l-40.347 40.346a23.378 23.378 0 00-10.463-2.462c-12.976 0-23.532 10.557-23.532 23.532 0 3.757.89 7.309 2.462 10.463l-16.298 16.298a7.5 7.5 0 005.304 12.802zm32.064-48.096c4.705 0 8.532 3.828 8.532 8.532s-3.828 8.532-8.532 8.532-8.532-3.828-8.532-8.532 3.828-8.532 8.532-8.532zm0-56.114a7.5 7.5 0 007.5-7.5v-8.016a7.5 7.5 0 00-15 0v8.016a7.5 7.5 0 007.5 7.5zm0 129.291a7.5 7.5 0 00-7.5 7.5v8.016a7.5 7.5 0 0015 0v-8.016a7.5 7.5 0 00-7.5-7.5zm72.145-57.145h8.016a7.5 7.5 0 000-15h-8.016a7.5 7.5 0 000 15zm-136.79-7.5a7.5 7.5 0 00-7.5-7.5h-8.016a7.5 7.5 0 000 15h8.016a7.5 7.5 0 007.5-7.5zm-39.565 96.709H7.5a7.5 7.5 0 000 15h80.161a7.5 7.5 0 000-15zm-8.016 32.065H31.548a7.5 7.5 0 000 15h48.097a7.5 7.5 0 000-15zm-8.016 32.064H55.597a7.5 7.5 0 000 15h16.032a7.5 7.5 0 000-15z"
        data-original="#000000"
      ></path>
    </svg>
  );
}

export default Shipping;